module.exports = __webpack_public_path__ + "img/hr-red-asterisk-05.faf07b82.png";